/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminProfileAssociatedContact,
  AdminV1OrganizationsProfilesAssociatedContactsListParams,
  PaginatedAdminProfileAssociatedContactList,
  PatchedAdminProfileAssociatedContact
} from '.././model';

import adminV1OrganizationsProfilesAssociatedContactsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesAssociatedContactsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesAssociatedContactsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesAssociatedContactsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesAssociatedContactsPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsProfilesAssociatedContactsDestroyMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const adminV1OrganizationsProfilesAssociatedContactsList = (
    organizationId: number,
    profilePk: number,
    params?: AdminV1OrganizationsProfilesAssociatedContactsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesAssociatedContactsListMutator<PaginatedAdminProfileAssociatedContactList>>,) => {
      return adminV1OrganizationsProfilesAssociatedContactsListMutator<PaginatedAdminProfileAssociatedContactList>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${profilePk}/associated_contacts/`, method: 'GET',
        params
    },
      options);
    }
  export const adminV1OrganizationsProfilesAssociatedContactsCreate = (
    organizationId: number,
    profilePk: number,
    adminProfileAssociatedContact: NonReadonly<AdminProfileAssociatedContact>,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesAssociatedContactsCreateMutator<AdminProfileAssociatedContact>>,) => {
      return adminV1OrganizationsProfilesAssociatedContactsCreateMutator<AdminProfileAssociatedContact>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${profilePk}/associated_contacts/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminProfileAssociatedContact
    },
      options);
    }
  export const adminV1OrganizationsProfilesAssociatedContactsRetrieve = (
    organizationId: number,
    profilePk: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesAssociatedContactsRetrieveMutator<AdminProfileAssociatedContact>>,) => {
      return adminV1OrganizationsProfilesAssociatedContactsRetrieveMutator<AdminProfileAssociatedContact>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${profilePk}/associated_contacts/${id}/`, method: 'GET'
    },
      options);
    }
  export const adminV1OrganizationsProfilesAssociatedContactsUpdate = (
    organizationId: number,
    profilePk: number,
    id: number,
    adminProfileAssociatedContact: NonReadonly<AdminProfileAssociatedContact>,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesAssociatedContactsUpdateMutator<AdminProfileAssociatedContact>>,) => {
      return adminV1OrganizationsProfilesAssociatedContactsUpdateMutator<AdminProfileAssociatedContact>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${profilePk}/associated_contacts/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminProfileAssociatedContact
    },
      options);
    }
  export const adminV1OrganizationsProfilesAssociatedContactsPartialUpdate = (
    organizationId: number,
    profilePk: number,
    id: number,
    patchedAdminProfileAssociatedContact: NonReadonly<PatchedAdminProfileAssociatedContact>,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesAssociatedContactsPartialUpdateMutator<AdminProfileAssociatedContact>>,) => {
      return adminV1OrganizationsProfilesAssociatedContactsPartialUpdateMutator<AdminProfileAssociatedContact>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${profilePk}/associated_contacts/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminProfileAssociatedContact
    },
      options);
    }
  /**
 * Remove the contact from the profile. If the contact is the primary contact, remove the association.
 * @summary Remove the contact from the profile. If the contact is the primary contact, remove the association.
 */
export const adminV1OrganizationsProfilesAssociatedContactsDestroy = (
    organizationId: number,
    profilePk: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsProfilesAssociatedContactsDestroyMutator<void>>,) => {
      return adminV1OrganizationsProfilesAssociatedContactsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/profiles/${profilePk}/associated_contacts/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type AdminV1OrganizationsProfilesAssociatedContactsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesAssociatedContactsList>>>
export type AdminV1OrganizationsProfilesAssociatedContactsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesAssociatedContactsCreate>>>
export type AdminV1OrganizationsProfilesAssociatedContactsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesAssociatedContactsRetrieve>>>
export type AdminV1OrganizationsProfilesAssociatedContactsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesAssociatedContactsUpdate>>>
export type AdminV1OrganizationsProfilesAssociatedContactsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesAssociatedContactsPartialUpdate>>>
export type AdminV1OrganizationsProfilesAssociatedContactsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsProfilesAssociatedContactsDestroy>>>
